<nav class="breadcrumbs">
	<ng-container *ngFor="let c of crumbs; let i = index; let l = last">
		<li>
			<a class="textlink" [href]="crumbLink(c, i)" [attr.data-content]="'Blog Breadcrumbs, ' + c" (click)="analyticsService.trackInput($event)">
				{{ 
					contentService.getDataByID(
						contentService.slugToID(c, entries), 
						'fields.title', 
						entries
					) || c 
					}}
			</a>
		</li>
		{{ l ? '' : '&nbsp;&nbsp;&rangle;&nbsp;' }}
	</ng-container>
</nav>
